// extracted by mini-css-extract-plugin
export default {"body":"body-jeywkVlQ"};